import type { ChannelId } from '@/Enums/ChannelId.enum';
import DateFormat from '@/Enums/Format/DateFormat.enum';
import type { ILineItemDuplicate } from '@/Interfaces/CampaignManagement/LineItem.interface';
import type { IPackage } from '@/Interfaces/Packages/Package.interface';
import type { IProduct } from '@/Interfaces/Product.interface';
import type { ISODateString } from '@/types/DateTime.type';
import moment from 'moment';

interface ILineItemDuplicateApi
  extends Omit<
    ILineItemDuplicate,
    'impressionsBooked' | 'startDate' | 'endDate' | 'product' | 'packageId' | 'channel'
  > {
  impressionsBudget: number;
  startDate: ISODateString;
  endDate: ISODateString;
  productId?: IProduct['id'];
  packageId?: IPackage['id'];
  channelId: ChannelId;
}

export default class LineItemService {
  public static mapLineItemsDuplicates(duplicates: ILineItemDuplicate[]): ILineItemDuplicateApi[] {
    return duplicates.map(
      ({
        impressionsBooked,
        startDate: duplicateStartDate,
        endDate: duplicateEndDate,
        product,
        packageId,
        channel,
        ...restDuplicate
      }) => {
        // Orgs on Packages have no Products, so a duplicate is targeted by either one or the other
        if (!duplicateStartDate || !duplicateEndDate || (!product?.id && !packageId) || !channel) {
          throw new Error(
            'Duplicate line item is missing required fields: startDate, endDate, channel, or product/package',
          );
        }

        return {
          ...restDuplicate,
          impressionsBudget: Number.parseInt(impressionsBooked),
          startDate: moment.utc(duplicateStartDate).format(DateFormat.Iso8601WithTime),
          endDate: moment.utc(duplicateEndDate).format(DateFormat.Iso8601WithTime),
          ...(product?.id && { productId: product.id }),
          ...(packageId && { packageId }),
          channelId: channel.value,
        };
      },
    );
  }
}
